import { createGlobalStyle} from "styled-components";
import GillSans from '../assets/fonts/GillSans.woff2';
import GillSansSemiBold from '../assets/fonts/GillSans-SemiBold.woff2';
import GillSansBold from '../assets/fonts/GillSans-Bold.woff2';


export const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&display=swap');

  @font-face {
    font-family: "GillSans";
    src: url(${GillSans}) format('woff2');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: "GillSans";
    src: url(${GillSansSemiBold}) format('woff2');
    font-weight: 500;
    font-style: normal;
  }
  
  @font-face {
    font-family: "GillSans";
    src: url(${GillSansBold}) format('woff2');
    font-weight: 700;
    font-style: normal;
  }

  body {
    font-family: 'Open Sans', sans-serif;
    font-size: 12px;
    background: linear-gradient(180deg, ${props => props.theme.colors.background} 0%, #FFFFFF 50%);
    background-repeat: no-repeat;
    min-height: 100vh;
    padding: 0;
    margin: 0;
  }
`;